import { EB_YIBF_ISIN_DURUMU } from "../constants/requestUrls";
import { getRequest } from "../request";

const ebYibfIsinDurumuList = () => {
    return getRequest({url:EB_YIBF_ISIN_DURUMU});
}

export default ebYibfIsinDurumuList;